import React, { useEffect, useState, useRef } from "react";
import "./DigitalPass.css";
import axios from "../../authAxios";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { MdPassword } from "react-icons/md";

export default function () {
  const navigate = useNavigate();
  const { token } = useParams();
  const [passDetails, setPassDetails] = useState();
  const qrCodeRef = useRef(null); // Ref for QR code image
  const visitorImageRef = useRef(null); // Ref for visitor image

  useEffect(() => {
    fetchVisitData();
  }, []);

  useEffect(() => {
    // Dynamically set the visitor image height equal to the QR code's height
    if (qrCodeRef.current && visitorImageRef.current) {
      visitorImageRef.current.style.height = `${qrCodeRef.current.offsetHeight}px`;
    }
  }, [passDetails]); // Run this effect when passDetails updates

  const fetchVisitData = () => {
    try {
      axios
        .get("/get-digital-pass/" + token)
        .then((response) => {
          if (response.data.status) {
            setPassDetails(response.data.data.digitalPass);
            return;
          }
        })
        .catch((error) => {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Error in getting visitor details",
            showConfirmButton: false,
            timer: 1500,
          });
        });
    } catch (error) {
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Error in getting visitor details",
        showConfirmButton: false,
        timer: 1500,
      });
    }
  };

  function formatTimestamp(timestamp) {
    // Convert string to Date object
    var date = new Date(timestamp);

    var months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    var month = months[date.getMonth()];
    var day = date.getDate();
    var year = date.getFullYear();
    var hours = date.getHours();
    var minutes = date.getMinutes();

    var ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;

    var formattedTime =
      hours + ":" + (minutes < 10 ? "0" : "") + minutes + " " + ampm;
    var formattedDate = day + " " + month + " " + year;

    return formattedTime + " - " + formattedDate;
  }

  const formatStatusColor = (status) => {
    if (status === "PENDING") {
      return "#184CCF";
    } else if (status === "APPROVED") {
      return "green";
    } else if (status === "REJECTED") {
      return "red";
    }
    return "black";
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          margin: "10px 20px",
          flexDirection: "column",
        }}
      >
        <div>
          <div
            style={{
              backgroundColor: "#E2E6F0",
              border: "3px dashed grey",
              padding: "8px 16px",
              borderRadius: "5px",
            }}
          >
            <h4 style={{ fontWeight: "600" }}>Visitor:</h4>
            <div
              style={{ padding: "10px 0px", borderBottom: "2px dashed grey" }}
            >
              <h5 style={{ color: "grey", margin: "0px" }}>Clock in:</h5>
              <h4>{formatTimestamp(passDetails?.checkin_time)}</h4>
              <div style={{ display: "flex" }}>
                <h4>
                  Status:{" "}
                  <span
                    style={{
                      color: formatStatusColor(passDetails?.visit_status),
                    }}
                  >
                    {passDetails?.visit_status}
                  </span>
                </h4>
              </div>
              <div style={{display:'flex',justifyContent:'space-between'}}>
                <img
                  ref={visitorImageRef} // Ref for visitor image
                  style={{ width: "120px", height: "120px" }}
                  src={passDetails?.visitor_image}
                  alt="Visitor"
                />
                <img
                  ref={qrCodeRef} // Ref for QR code image
                  style={{ width: "120px", height: "120px" }}
                  src={passDetails?.qrCode}
                  alt="QRCode"
                />
              </div>
              <div style={{ display: "flex" }}>
                <h4>
                  Name: <span>{passDetails?.visitor_name}</span>
                </h4>
              </div>
              <div style={{ display: "flex" }}>
                <h4>
                  Mobile: <span>{passDetails?.visitor_phone_no}</span>
                </h4>
              </div>
              <div style={{ display: "flex" }}>
                <h4>
                  Email: <span>{passDetails?.visitor_email}</span>
                </h4>
              </div>
              <div style={{ display: "flex" }}>
                <h4>
                  Reason to Meet: <span>{passDetails?.reason}</span>{" "}
                </h4>
              </div>
            </div>
            <div style={{ padding: "15px 0px" }}>
              <h4 style={{ fontWeight: "600" }}>Meeting With:</h4>
              <div style={{ display: "flex" }}>
                <h4>
                  Name: <span>{passDetails?.employeeName}</span>
                </h4>
              </div>
              <div style={{ display: "flex" }}>
                <h4>
                  Emp ID: <span>{passDetails?.employee_id}</span>
                </h4>
              </div>
              <div style={{ display: "flex" }}>
                <h4>
                  Email: <span>{passDetails?.employeeEmail}</span>
                </h4>
              </div>
            </div>
          </div>
          <div>
            <button
              onClick={() => {
                navigate(-1);
              }}
              style={{
                padding: "8px 16px",
                backgroundColor: "var(--primary-color)",
                width: "100%",
                color: "white",
                border: "5px",
                marginTop: "15px",
              }}
            >
              Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
